// The 13 outboard motor form fields, persisted together in the outboard_spec
// jsonb column (mirrors the chipper_spec / stump_grinder_spec pattern).
const OB_FIELDS = [
  "obShaftLength", "obTransomHeight", "obTiltTrim", "obSteering",
  "obPropPitch", "obPropDiameter", "obPropMaterial", "obGearRatio",
  "obLowerUnitOilType", "obLowerUnitOilCapacity", "obAnodeMaterial",
  "obBreakInHours", "obImpellerLastChanged",
];

function obSpecToDb(m) {
  const spec = {};
  let any = false;
  for (const k of OB_FIELDS) {
    if (m[k] != null && m[k] !== "") { spec[k] = m[k]; any = true; }
  }
  return any ? spec : null;
}

function obSpecFromDb(r) {
  const spec = r.outboard_spec || {};
  const out = {};
  for (const k of OB_FIELDS) out[k] = spec[k] ?? "";
  return out;
}

export function toDb(m) {
  return {
    id:                   m.id,
    user_id:              m.userId || null,
    company_id:           m.companyId || null,
    client_id:            m.clientId || null,
    name:                 m.name,
    type:                 m.type,
    make:                 m.make,
    model:                m.model,
    source:               m.source,
    on_bench:             !!m.onBench,
    complete:             !!m.complete,
    estimated_value:      (m.estimatedValue != null && m.estimatedValue !== '') ? parseFloat(m.estimatedValue) : null,
    sold_at:              m.soldAt || null,
    description:          m.desc,
    year:                 m.year,
    colour:               m.colour,
    body_type:            m.bodyType,
    drive_config:         m.driveConfig,
    notes:                m.notes,
    rage:                 m.rage || 0,
    photos:               m.photos || [],
    stroke_type:          m.strokeType,
    motor_type:           m.motorType,
    motor_power:          m.motorPower,
    motor_torque:         m.motorTorque,
    controller_brand:     m.controllerBrand,
    pack_voltage:         m.packVoltage,
    pack_capacity:        m.packCapacity,
    batt_chemistry:       m.battChemistry,
    cell_count:           m.cellCount,
    charge_port:          m.chargePort,
    max_charge_rate:      m.maxChargeRate,
    ev_range:             m.evRange,
    regen_braking:        m.regenBraking,
    cyl_count:            m.cylCount,
    firing_order:         m.firingOrder,
    cc_size:              m.ccSize,
    compression:          m.compression,
    idle_rpm:             m.idleRpm,
    wot_rpm:              m.wotRpm,
    bore_diameter:        m.boreDiameter,
    plug_type:            m.plugType,
    plug_gap:             m.plugGap,
    coil_type:            m.coilType,
    primary_ohms:         m.primaryOhms,
    secondary_ohms:       m.secondaryOhms,
    starter_type:         m.starterType,
    rope_diameter:        m.ropeDiameter,
    rope_length:          m.ropeLength,
    r_bolt_n:             m.rBoltN,
    r_bolt_sz:            m.rBoltSz,
    r_bolt_len:           m.rBoltLen,
    valve_train:          m.valveTrain,
    cam_type:             m.camType,
    locknut_size:         m.locknutSize,
    intake_valve_clear:   m.intakeValveClear,
    exhaust_valve_clear:  m.exhaustValveClear,
    intake_valve_n:       m.intakeValveN,
    exhaust_valve_n:      m.exhaustValveN,
    i_valve_face:         m.iValveFace,
    i_valve_stem:         m.iValveStem,
    i_valve_lift:         m.iValveLift,
    i_valve_weight:       m.iValveWeight,
    e_valve_face:         m.eValveFace,
    e_valve_stem:         m.eValveStem,
    e_valve_lift:         m.eValveLift,
    e_valve_weight:       m.eValveWeight,
    spring_free_len:      m.springFreeLen,
    spring_outer_d:       m.springOuterD,
    spring_wire_d:        m.springWireD,
    spring_weight:        m.springWeight,
    i_pw:                 m.iPW,
    i_ph:                 m.iPH,
    i_p_cond:             m.iPCond,
    i_p_notes:            m.iPNotes,
    i_p_photos:           m.iPPhotos || [],
    e_pw:                 m.ePW,
    e_ph:                 m.ePH,
    e_p_cond:             m.ePCond,
    e_p_notes:            m.ePNotes,
    e_p_photos:           m.ePPhotos || [],
    bar_length:           m.barLength,
    bar_gauge:            m.barGauge,
    bar_mount:            m.barMount,
    bar_stud_diameter:    m.barStudDiameter,
    bar_nut_type:         m.barNutType,
    bar_nut_size:         m.barNutSize,
    chain_pitch_cs:       m.chainPitchCS,
    chain_gauge:          m.chainGauge,
    chain_drive_links:    m.chainDriveLinks,
    chain_part_no:        m.chainPartNo,
    chain_brand:          m.chainBrand,
    sprocket_style:       m.sprocketStyle,
    sprocket_pitch_cs:    m.sprocketPitchCS,
    sprocket_teeth_cs:    m.sprocketTeethCS,
    clutch2t_type:        m.clutch2TType,
    clutch_drum_diameter: m.clutchDrumDiameter,
    clutch_shoe_count:    m.clutchShoeCount,
    clutch_engage_rpm:    m.clutchEngageRpm,
    clutch_bearing_part:  m.clutchBearingPart,
    clutch2t_notes:       m.clutch2TNotes,
    pulse_loc:            m.pulseLoc,
    pulse_pos:            m.pulsePos,
    pulse_offset:         m.pulseOffset,
    pto_diameter:         m.ptoDiameter,
    input_shaft_diameter: m.inputShaftDiameter,
    input_shaft_splines:  m.inputShaftSplines,
    input_shaft_thread:   m.inputShaftThread,
    output_shaft_diameter:m.outputShaftDiameter,
    output_shaft_splines: m.outputShaftSplines,
    output_shaft_thread:  m.outputShaftThread,
    prop_shaft_diameter:  m.propShaftDiameter,
    gearbox_shaft_notes:  m.gearboxShaftNotes,
    shaft_type:           m.shaftType,
    thread_dir:           m.threadDir,
    thread_size:          m.threadSize,
    sprocket_type:        m.sprocketType,
    fuel_system:          m.fuelSystem,
    fuel_tank_capacity:   m.fuelTankCapacity,
    mix_ratio:            m.mixRatio,
    c_brand:              m.cBrand,
    carb_count:           m.carbCount,
    c_type:               m.cType,
    c_model:              m.cModel,
    ecu_model:            m.ecuModel,
    tb_diameter:          m.tbDiameter,
    injector_count:       m.injectorCount,
    injector_flow:        m.injectorFlow,
    fuel_rail_pressure:   m.fuelRailPressure,
    fuel_pump_pressure:   m.fuelPumpPressure,
    tps_sensor:           m.tpsSensor,
    map_sensor:           m.mapSensor,
    iat_sensor:           m.iatSensor,
    o2_sensor:            m.o2Sensor,
    iac_sensor:           m.iacSensor,
    fasteners:            m.fasteners || [],
    studs:                m.studs || [],
    i_spacing:            m.iSpacing,
    i_studs:              m.iStuds,
    i_bolt_sz:            m.iBoltSz,
    i_bolt_len:           m.iBoltLen,
    e_spacing:            m.eSpacing,
    e_studs:              m.eStuds,
    e_bolt_sz:            m.eBoltSz,
    e_bolt_len:           m.eBoltLen,
    pump_brand:           m.pumpBrand,
    pump_model:           m.pumpModel,
    pump_psi:             m.pumpPsi,
    pump_flow:            m.pumpFlow,
    pump_inlet:           m.pumpInlet,
    pump_outlet:          m.pumpOutlet,
    pump_type:            m.pumpType,
    gen_watts:            m.genWatts,
    gen_peak_watts:       m.genPeakWatts,
    gen_voltage:          m.genVoltage,
    gen_freq:             m.genFreq,
    gen_avr:              m.genAvr,
    gen_outlets:          m.genOutlets,
    drive_type:           m.driveType,
    gearbox_brand:        m.gearboxBrand,
    clutch_type:          m.clutchType,
    clutch_diameter:      m.clutchDiameter,
    torque_converter:     m.torqueConverter,
    auto_speeds:          m.autoSpeeds,
    auto_fluid_type:      m.autoFluidType,
    auto_fluid_capacity:  m.autoFluidCapacity,
    cvt_belt_type:        m.cvtBeltType,
    gearbox_oil_type:     m.gearboxOilType,
    gearbox_oil_capacity: m.gearboxOilCapacity,
    chain_pitch:          m.chainPitch,
    front_sprocket:       m.frontSprocket,
    rear_sprocket:        m.rearSprocket,
    gear_count:           m.gearCount,
    trans_type:           m.transType,
    fork_type:            m.forkType,
    fork_diameter:        m.forkDiameter,
    fork_travel:          m.forkTravel,
    rear_shock_type:      m.rearShockType,
    rear_travel:          m.rearTravel,
    front_brake:          m.frontBrake,
    front_disc_d:         m.frontDiscD,
    front_disc_w:         m.frontDiscW,
    rear_brake:           m.rearBrake,
    rear_disc_d:          m.rearDiscD,
    rear_disc_w:          m.rearDiscW,
    tyre_front:           m.tyreFront,
    tyre_rear:            m.tyreRear,
    rim_front:            m.rimFront,
    rim_rear:             m.rimRear,
    batt_voltage:         m.battVoltage,
    battery_cca:          m.batteryCCA,
    battery_ah:           m.batteryAh,
    battery_dimensions:   m.batteryDimensions,
    starter_motor_type:   m.starterMotorType,
    fuse_boxes:           m.fuseBoxes || [],
    deck_size:            m.deckSize,
    blade_length:         m.bladeLength,
    blade_type:           m.bladeType,
    blade_count:          m.bladeCount,
    tile_fields:          m.tileFields || [],
    tile_colors:          m.tileColors || {},
    expand_fields:        m.expandFields || [],
    custom_sections:      m.customSections || null,
    submitted_to_wiki:    m.submittedToWiki || false,
    wiki_machine_id:      m.wikiMachineId || null,
    tracked_brand:        m.trackedBrand,
    tracked_hours:        m.trackedHours,
    tracked_brand_other:  m.trackedBrandOther,
    tracked_subtype:      m.trackedSubtype,
    tracked_subtype_other:m.trackedSubtypeOther,
    operating_weight:     m.operatingWeight,
    operating_weight_other:m.operatingWeightOther,
    track_type:           m.trackType,
    track_width:          m.trackWidth,
    track_pitch:          m.trackPitch,
    track_links:          m.trackLinks,
    sprocket_teeth:       m.sprocketTeeth,
    undercarriage_hours:  m.undercarriageHours,
    hyd_pump_count:       m.hydPumpCount,
    hyd_pump_type:        m.hydPumpType,
    hyd_system_pressure:  m.hydSystemPressure,
    hyd_oil_capacity:     m.hydOilCapacity,
    hyd_relief_valve:     m.hydReliefValve,
    hyd_rams:             m.hydRams || [],
    attachments:          m.attachments || [],
    bearings:             m.bearings || [],
    lighting:             m.lighting || [],
    belts:                m.belts || [],
    parts:                m.parts || [],
    batteries:            m.batteries || [],
    cooling_type:         m.coolingType,
    coolant_type:         m.coolantType,
    coolant_capacity:     m.coolantCapacity,
    thermostat_temp:      m.thermostatTemp,
    cooling_notes:        m.coolingNotes,
    turbo_fitted:         m.turboFitted,
    turbo_type:           m.turboType,
    turbo_brand:          m.turboBrand,
    turbo_boost:          m.turboBoost,
    intercooler:          m.intercooler,
    turbo_notes:          m.turboNotes,
    charging_type:        m.chargingType,
    charge_voltage:       m.chargeVoltage,
    charge_amps:          m.chargeAmps,
    rect_reg_fitted:      m.rectRegFitted,
    charging_notes:       m.chargingNotes,
    cyl_max_wear:         m.cylMaxWear,
    cyl_taper_limit:      m.cylTaperLimit,
    cyl_out_of_round:     m.cylOutOfRound,
    honing_angle:         m.honingAngle,
    nikasil:              m.nikasil,
    main_bearing_type:    m.mainBearingType,
    main_bearing_left:    m.mainBearingLeft,
    main_bearing_right:   m.mainBearingRight,
    main_bearing_clear:   m.mainBearingClear,
    main_bearing_preload: m.mainBearingPreload,
    crank_pin_diameter:   m.crankPinDiameter,
    crank_pin_length:     m.crankPinLength,
    main_journal_diameter:m.mainJournalDiameter,
    crank_end_float:      m.crankEndFloat,
    crank_runout:         m.crankRunout,
    crank_stroke:         m.crankStroke,
    crank_seal_left:      m.crankSealLeft,
    crank_seal_right:     m.crankSealRight,
    conrod_length:        m.conrodLength,
    conrod_small_end:     m.conrodSmallEnd,
    conrod_small_clear:   m.conrodSmallClear,
    conrod_big_end:       m.conrodBigEnd,
    conrod_big_clear:     m.conrodBigClear,
    conrod_side_clear:    m.conrodSideClear,
    conrod_bearing_type:  m.conrodBearingType,
    conrod_bearing_part:  m.conrodBearingPartNo,
    piston_diameter:      m.pistonDiameter,
    piston_clearance:     m.pistonClearance,
    ring_count:           m.ringCount,
    ring_gap_top:         m.ringGapTop,
    ring_gap_second:      m.ringGapSecond,
    ring_gap_oil:         m.ringGapOil,
    ring_width:           m.ringWidth,
    ring_thickness:       m.ringThickness,
    gudgeon_diameter:     m.gudgeonDiameter,
    gudgeon_length:       m.gudgeonLength,
    gudgeon_fit:          m.gudgeonFit,
    gudgeon_circlip:      m.gudgeonCirclip,
    oil_change_interval:  m.oilChangeInterval,
    oil_change_unit:      m.oilChangeUnit,
    filter_interval:      m.filterInterval,
    filter_interval_unit: m.filterIntervalUnit,
    major_service_interval:m.majorServiceInterval,
    major_service_unit:   m.majorServiceUnit,
    last_service_odo:     m.lastServiceOdo,
    last_service_date:    m.lastServiceDate || null,
    engine_oil_grade:     m.engineOilGrade,
    engine_oil_brand:     m.engineOilBrand || null,
    engine_oil_jaso:      m.engineOilJaso || null,
    engine_oil_synth:     m.engineOilSynth || null,
    engine_oil_capacity:  m.engineOilCapacity,
    hydraulic_fluid_type: m.hydraulicFluidType,
    brake_fluid_type:     m.brakeFluidType,
    diff_oil_type:        m.diffOilType,
    diff_oil_capacity:    m.diffOilCapacity,
    transfer_case_oil:    m.transferCaseOil,
    dry_weight:           m.dryWeight,
    gross_weight:         m.grossWeight,
    wheelbase:            m.wheelbase,
    overall_length:       m.overallLength,
    overall_width:        m.overallWidth,
    overall_height:       m.overallHeight,
    carb_spec:            m.carbSpec || null,
    chipper_spec:         m.chipperSpec || null,
    stump_grinder_spec:   m.stumpGrinderSpec || null,
    outboard_spec:        obSpecToDb(m),
    due_date:             m.dueDate || null,
    compression_ratio:    m.compressionRatio,
    total_load_watts:     m.totalLoadWatts,
    ground_contact_length:m.groundContactLength,
    last_service_notes:   m.lastServiceNotes || null,
    job_timer:            m.jobTimers || [],
    time_log:             m.timeLog || [],
  };
}

export function fromDb(r) {
  return {
    id:                r.id,
    userId:            r.user_id,
    clientId:          r.client_id,
    companyId:         r.company_id || null,
    name:              r.name,
    type:              r.type,
    make:              r.make,
    model:             r.model,
    source:            r.source,
    onBench:           !!r.on_bench,
    complete:          !!r.complete,
    estimatedValue:    r.estimated_value,
    soldAt:            r.sold_at || null,
    desc:              r.description,
    year:              r.year,
    colour:            r.colour,
    bodyType:          r.body_type,
    driveConfig:       r.drive_config,
    notes:             r.notes,
    rage:              r.rage || 0,
    photos:            r.photos || [],
    strokeType:        r.stroke_type,
    motorType:         r.motor_type,
    motorPower:        r.motor_power,
    motorTorque:       r.motor_torque,
    controllerBrand:   r.controller_brand,
    packVoltage:       r.pack_voltage,
    packCapacity:      r.pack_capacity,
    battChemistry:     r.batt_chemistry,
    cellCount:         r.cell_count,
    chargePort:        r.charge_port,
    maxChargeRate:     r.max_charge_rate,
    evRange:           r.ev_range,
    regenBraking:      r.regen_braking,
    cylCount:          r.cyl_count,
    firingOrder:       r.firing_order,
    ccSize:            r.cc_size,
    compression:       r.compression,
    idleRpm:           r.idle_rpm,
    wotRpm:            r.wot_rpm,
    boreDiameter:      r.bore_diameter,
    plugType:          r.plug_type,
    plugGap:           r.plug_gap,
    coilType:          r.coil_type,
    primaryOhms:       r.primary_ohms,
    secondaryOhms:     r.secondary_ohms,
    starterType:       r.starter_type,
    ropeDiameter:      r.rope_diameter,
    ropeLength:        r.rope_length,
    rBoltN:            r.r_bolt_n,
    rBoltSz:           r.r_bolt_sz,
    rBoltLen:          r.r_bolt_len,
    valveTrain:        r.valve_train,
    camType:           r.cam_type,
    locknutSize:       r.locknut_size,
    intakeValveClear:  r.intake_valve_clear,
    exhaustValveClear: r.exhaust_valve_clear,
    intakeValveN:      r.intake_valve_n,
    exhaustValveN:     r.exhaust_valve_n,
    iValveFace:        r.i_valve_face,
    iValveStem:        r.i_valve_stem,
    iValveLift:        r.i_valve_lift,
    iValveWeight:      r.i_valve_weight,
    eValveFace:        r.e_valve_face,
    eValveStem:        r.e_valve_stem,
    eValveLift:        r.e_valve_lift,
    eValveWeight:      r.e_valve_weight,
    springFreeLen:     r.spring_free_len,
    springOuterD:      r.spring_outer_d,
    springWireD:       r.spring_wire_d,
    springWeight:      r.spring_weight,
    iPW:               r.i_pw,
    iPH:               r.i_ph,
    iPCond:            r.i_p_cond,
    iPNotes:           r.i_p_notes,
    iPPhotos:          r.i_p_photos || [],
    ePW:               r.e_pw,
    ePH:               r.e_ph,
    ePCond:            r.e_p_cond,
    ePNotes:           r.e_p_notes,
    ePPhotos:          r.e_p_photos || [],
    barLength:         r.bar_length,
    barGauge:          r.bar_gauge,
    barMount:          r.bar_mount,
    barStudDiameter:   r.bar_stud_diameter,
    barNutType:        r.bar_nut_type,
    barNutSize:        r.bar_nut_size,
    chainPitchCS:      r.chain_pitch_cs,
    chainGauge:        r.chain_gauge,
    chainDriveLinks:   r.chain_drive_links,
    chainPartNo:       r.chain_part_no,
    chainBrand:        r.chain_brand,
    sprocketStyle:     r.sprocket_style,
    sprocketPitchCS:   r.sprocket_pitch_cs,
    sprocketTeethCS:   r.sprocket_teeth_cs,
    clutch2TType:      r.clutch2t_type,
    clutchDrumDiameter:r.clutch_drum_diameter,
    clutchShoeCount:   r.clutch_shoe_count,
    clutchEngageRpm:   r.clutch_engage_rpm,
    clutchBearingPart: r.clutch_bearing_part,
    clutch2TNotes:     r.clutch2t_notes,
    pulseLoc:          r.pulse_loc,
    pulsePos:          r.pulse_pos,
    pulseOffset:       r.pulse_offset,
    ptoDiameter:       r.pto_diameter,
    inputShaftDiameter:r.input_shaft_diameter,
    inputShaftSplines: r.input_shaft_splines,
    inputShaftThread:  r.input_shaft_thread,
    outputShaftDiameter:r.output_shaft_diameter,
    outputShaftSplines:r.output_shaft_splines,
    outputShaftThread: r.output_shaft_thread,
    propShaftDiameter: r.prop_shaft_diameter,
    gearboxShaftNotes: r.gearbox_shaft_notes,
    shaftType:         r.shaft_type,
    threadDir:         r.thread_dir,
    threadSize:        r.thread_size,
    sprocketType:      r.sprocket_type,
    fuelSystem:        r.fuel_system,
    fuelTankCapacity:  r.fuel_tank_capacity,
    mixRatio:          r.mix_ratio,
    cBrand:            r.c_brand,
    carbCount:         r.carb_count,
    cType:             r.c_type,
    cModel:            r.c_model,
    ecuModel:          r.ecu_model,
    tbDiameter:        r.tb_diameter,
    injectorCount:     r.injector_count,
    injectorFlow:      r.injector_flow,
    fuelRailPressure:  r.fuel_rail_pressure,
    fuelPumpPressure:  r.fuel_pump_pressure,
    tpsSensor:         r.tps_sensor,
    mapSensor:         r.map_sensor,
    iatSensor:         r.iat_sensor,
    o2Sensor:          r.o2_sensor,
    iacSensor:         r.iac_sensor,
    fasteners:         r.fasteners || [],
    studs:             r.studs || [],
    iSpacing:          r.i_spacing,
    iStuds:            r.i_studs,
    iBoltSz:           r.i_bolt_sz,
    iBoltLen:          r.i_bolt_len,
    eSpacing:          r.e_spacing,
    eStuds:            r.e_studs,
    eBoltSz:           r.e_bolt_sz,
    eBoltLen:          r.e_bolt_len,
    pumpBrand:         r.pump_brand,
    pumpModel:         r.pump_model,
    pumpPsi:           r.pump_psi,
    pumpFlow:          r.pump_flow,
    pumpInlet:         r.pump_inlet,
    pumpOutlet:        r.pump_outlet,
    pumpType:          r.pump_type,
    genWatts:          r.gen_watts,
    genPeakWatts:      r.gen_peak_watts,
    genVoltage:        r.gen_voltage,
    genFreq:           r.gen_freq,
    genAvr:            r.gen_avr,
    genOutlets:        r.gen_outlets,
    driveType:         r.drive_type,
    gearboxBrand:      r.gearbox_brand,
    clutchType:        r.clutch_type,
    clutchDiameter:    r.clutch_diameter,
    torqueConverter:   r.torque_converter,
    autoSpeeds:        r.auto_speeds,
    autoFluidType:     r.auto_fluid_type,
    autoFluidCapacity: r.auto_fluid_capacity,
    cvtBeltType:       r.cvt_belt_type,
    gearboxOilType:    r.gearbox_oil_type,
    gearboxOilCapacity:r.gearbox_oil_capacity,
    chainPitch:        r.chain_pitch,
    frontSprocket:     r.front_sprocket,
    rearSprocket:      r.rear_sprocket,
    gearCount:         r.gear_count,
    transType:         r.trans_type,
    forkType:          r.fork_type,
    forkDiameter:      r.fork_diameter,
    forkTravel:        r.fork_travel,
    rearShockType:     r.rear_shock_type,
    rearTravel:        r.rear_travel,
    frontBrake:        r.front_brake,
    frontDiscD:        r.front_disc_d,
    frontDiscW:        r.front_disc_w,
    rearBrake:         r.rear_brake,
    rearDiscD:         r.rear_disc_d,
    rearDiscW:         r.rear_disc_w,
    tyreFront:         r.tyre_front,
    tyreRear:          r.tyre_rear,
    rimFront:          r.rim_front,
    rimRear:           r.rim_rear,
    battVoltage:       r.batt_voltage,
    batteryCCA:        r.battery_cca,
    batteryAh:         r.battery_ah,
    batteryDimensions: r.battery_dimensions,
    starterMotorType:  r.starter_motor_type,
    fuseBoxes:         r.fuse_boxes || [],
    deckSize:          r.deck_size,
    bladeLength:       r.blade_length,
    bladeType:         r.blade_type,
    bladeCount:        r.blade_count,
    tileFields:        r.tile_fields || [],
    tileColors:        r.tile_colors || {},
    expandFields:      r.expand_fields || [],
    customSections:    r.custom_sections || null,
    submittedToWiki:   r.submitted_to_wiki || false,
    wikiMachineId:     r.wiki_machine_id || null,
    trackedBrand:      r.tracked_brand,
    trackedHours:      r.tracked_hours,
    trackedBrandOther: r.tracked_brand_other,
    trackedSubtype:    r.tracked_subtype,
    trackedSubtypeOther:r.tracked_subtype_other,
    operatingWeight:   r.operating_weight,
    operatingWeightOther:r.operating_weight_other,
    trackType:         r.track_type,
    trackWidth:        r.track_width,
    trackPitch:        r.track_pitch,
    trackLinks:        r.track_links,
    sprocketTeeth:     r.sprocket_teeth,
    undercarriageHours:r.undercarriage_hours,
    hydPumpCount:      r.hyd_pump_count,
    hydPumpType:       r.hyd_pump_type,
    hydSystemPressure: r.hyd_system_pressure,
    hydOilCapacity:    r.hyd_oil_capacity,
    hydReliefValve:    r.hyd_relief_valve,
    hydRams:           r.hyd_rams || [],
    attachments:       r.attachments || [],
    bearings:          r.bearings || [],
    lighting:          r.lighting || [],
    belts:             r.belts || [],
    batteries:         r.batteries || [],
    parts:             r.parts || [],
    coolingType:       r.cooling_type,
    coolantType:       r.coolant_type,
    coolantCapacity:   r.coolant_capacity,
    thermostatTemp:    r.thermostat_temp,
    coolingNotes:      r.cooling_notes,
    turboFitted:       r.turbo_fitted,
    turboType:         r.turbo_type,
    turboBrand:        r.turbo_brand,
    turboBoost:        r.turbo_boost,
    intercooler:       r.intercooler,
    turboNotes:        r.turbo_notes,
    chargingType:      r.charging_type,
    chargeVoltage:     r.charge_voltage,
    chargeAmps:        r.charge_amps,
    rectRegFitted:     r.rect_reg_fitted,
    chargingNotes:     r.charging_notes,
    cylMaxWear:        r.cyl_max_wear,
    cylTaperLimit:     r.cyl_taper_limit,
    cylOutOfRound:     r.cyl_out_of_round,
    honingAngle:       r.honing_angle,
    nikasil:           r.nikasil,
    mainBearingType:   r.main_bearing_type,
    mainBearingLeft:   r.main_bearing_left,
    mainBearingRight:  r.main_bearing_right,
    mainBearingClear:  r.main_bearing_clear,
    mainBearingPreload:r.main_bearing_preload,
    crankPinDiameter:  r.crank_pin_diameter,
    crankPinLength:    r.crank_pin_length,
    mainJournalDiameter:r.main_journal_diameter,
    crankEndFloat:     r.crank_end_float,
    crankRunout:       r.crank_runout,
    crankStroke:       r.crank_stroke,
    crankSealLeft:     r.crank_seal_left,
    crankSealRight:    r.crank_seal_right,
    conrodLength:      r.conrod_length,
    conrodSmallEnd:    r.conrod_small_end,
    conrodSmallClear:  r.conrod_small_clear,
    conrodBigEnd:      r.conrod_big_end,
    conrodBigClear:    r.conrod_big_clear,
    conrodSideClear:   r.conrod_side_clear,
    conrodBearingType: r.conrod_bearing_type,
    conrodBearingPartNo:r.conrod_bearing_part,
    pistonDiameter:    r.piston_diameter,
    pistonClearance:   r.piston_clearance,
    ringCount:         r.ring_count,
    ringGapTop:        r.ring_gap_top,
    ringGapSecond:     r.ring_gap_second,
    ringGapOil:        r.ring_gap_oil,
    ringWidth:         r.ring_width,
    ringThickness:     r.ring_thickness,
    gudgeonDiameter:   r.gudgeon_diameter,
    gudgeonLength:     r.gudgeon_length,
    gudgeonFit:        r.gudgeon_fit,
    gudgeonCirclip:    r.gudgeon_circlip,
    oilChangeInterval: r.oil_change_interval,
    oilChangeUnit:     r.oil_change_unit,
    filterInterval:    r.filter_interval,
    filterIntervalUnit:r.filter_interval_unit,
    majorServiceInterval:r.major_service_interval,
    majorServiceUnit:  r.major_service_unit,
    lastServiceOdo:    r.last_service_odo,
    lastServiceDate:   r.last_service_date || "",
    engineOilGrade:    r.engine_oil_grade,
    engineOilBrand:    r.engine_oil_brand || "",
    engineOilJaso:     r.engine_oil_jaso || "",
    engineOilSynth:    r.engine_oil_synth || "",
    engineOilCapacity: r.engine_oil_capacity,
    hydraulicFluidType:r.hydraulic_fluid_type,
    brakeFluidType:    r.brake_fluid_type,
    diffOilType:       r.diff_oil_type,
    diffOilCapacity:   r.diff_oil_capacity,
    transferCaseOil:   r.transfer_case_oil,
    dryWeight:         r.dry_weight,
    grossWeight:       r.gross_weight,
    wheelbase:         r.wheelbase,
    overallLength:     r.overall_length,
    overallWidth:      r.overall_width,
    overallHeight:     r.overall_height,
    createdAt:         r.created_at,
    carbSpec:          r.carb_spec || null,
    chipperSpec:       r.chipper_spec || null,
    stumpGrinderSpec:  r.stump_grinder_spec || null,
    ...obSpecFromDb(r),
    dueDate:           r.due_date || "",
    compressionRatio:  r.compression_ratio,
    totalLoadWatts:    r.total_load_watts,
    groundContactLength: r.ground_contact_length,
    lastServiceNotes:  r.last_service_notes || "",
    jobTimers:         (() => {
      const jt = r.job_timer;
      if (!jt) return [];
      if (Array.isArray(jt)) return jt;
      // Legacy single-object format — migrate if non-idle.
      // Id must be stable across reads or repeated load-save cycles rewrite
      // the timer's identity, so derive it from the machine id.
      if (jt.status && jt.status !== "idle") {
        return [{ ...jt, id: jt.id || `legacy-${r.id}`, startedBy: jt.startedBy || null }];
      }
      return [];
    })(),
    timeLog:           r.time_log || [],
  };
}

export function svcToDb(machineId, s) {
  return {
    id:           s.id,
    machine_id:   machineId,
    completed_at: s.completedAt,
    types:        s.types || [],
    notes:        s.notes,
    plug_photo:   s.plugPhoto || null,
    job_photos:   s.jobPhotos || [],
  };
}

export function svcFromDb(r) {
  return {
    id:          r.id,
    machineId:   r.machine_id,
    completedAt: r.completed_at,
    types:       r.types || [],
    notes:       r.notes,
    plugPhoto:   r.plug_photo,
    jobPhotos:   r.job_photos || [],
    createdAt:   r.created_at,
    updatedAt:   r.updated_at,
  };
}
